$(function(){
// グローバル変数、オブジェクト
var BREAK_POINT = 768,
	TAB_BREAK_POINT = 1024,
	$win = $(window),
	$html = $('html'),
	$body = $('body'),
	win_w = $win.width(),
	scl_top = 0,
	get_device = function(){
		var ua = navigator.userAgent;
		if(ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0){
			return 'sp';
		}else if(ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0){
			return 'tab';
		}else{
			return 'other';
		}
	},
	get_browser = function() {
		var browser = window.navigator.userAgent;

		if(browser.indexOf('Trident') != -1 ) {
			return 'msie';
		} else if(browser.indexOf('edge') != -1) {
			return 'edge';
		} else if(browser.indexOf('chrome') != -1) {
			return 'chrome';
		} else if(browser.indexOf('safari') != -1) {
			return 'safari';
		} else if (browser.indexOf('firefox') != -1) {
			return 'firefox';
		} else {
			return 'other';
		}
	},
	init = function(){ // 初期、リサイズで着火させる処理をまとめる
		init_matchheight();
	},
	set = function() {
		set_header_scroll();
		set_sp_header_accord();
		set_smooth_scroll();
		set_slick_slider();
		set_accord();
		set_textarea_auto();
		set_tel_autoformat();
		set_linkcopy();
		set_form_validation();
		set_simple_form_title();
		set_trial_add();
		set_action_ripple();
		set_toc_popup();
		set_banner_fix();
		set_infinite_scroll();
		set_sp_menu_switch();
		set_mixitup_filter();
		set_sp_filter_switch();
		set_terms_popup();
		set_blog_toc();
		set_support_toc();
		set_api_tabs();
		set_function_tabs();
		set_manual_menu();
		set_simple_form_title();
	},
	load = function() {
	}


/* =================================================
	events
================================================= */
$win.on('resize', function() {
	// リサイズによる値の変更
	win_w = $win.width();
	init();
});

set();
init();

$win.on('load', function() {
	load();
});


/* =================================================
	functions
================================================= */

/* スムーズスクロール */
function set_smooth_scroll() {
	if(	get_browser() != 'msie') {
		var scroll = new SmoothScroll('a[href*="#"]', {
		    speed: 750,
		    speedAsDuration: true,
		    easing: 'easeInOutQuad',
		    updateURL: false,
		});
	}
};

/* ヘッダー固定表示 */
function set_header_scroll() {

	// head scroll fixed
  	var $fixHeader   = $('.js-head'),
  		startpos     = 0,
	    viewPos = 50,
	    viewHiddenPos = 450;

	$win.on('scroll load', function() {
		var $this   = $(this),
            scrlTop = $this.scrollTop(),
            winH    = $this.height(),
            scrlPos = scrlTop + winH;

		//メニュー表示切替 ウィンドウよりviewPos以上
		if (scrlTop > viewPos) {
			$body.addClass("is-fixed-scroll");

			if(scrlTop > viewHiddenPos) {
				$body.addClass("is-hidden-scroll");
			}
			if (scrlTop < startpos ) {
				$body.removeClass("is-hidden-scroll");
			}
		}else{
			$body.removeClass("is-fixed-scroll");
		}
		startpos = scrlTop;
	});
};

/* ヘッダー固定表示 */
function set_sp_header_accord() {

	var $accord_btn = $('.js-head-accord');

	$accord_btn.on('click', function() {
		if(win_w <= TAB_BREAK_POINT) {

			var $this = $(this);
			var $accord_tar = $this.next('.js-head-accordTar');

			if($this.hasClass('is-open')) {
				$accord_tar.slideUp(300);
				$this.removeClass('is-open');
			}else{
				$accord_tar.slideDown(300);
				$this.addClass('is-open');
			}

		}
	});
};

/* slick slider */
function set_slick_slider() {

	// NEWSスライダー
	var $news_slider = $('.js-news-slider');

	if($news_slider.length > 0) {

		$news_slider.slick({
			dots: false,
			arrows: true,
			vertical: true,
			verticalSwiping: false,
			centerMode: true,
  			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 4000,
			speed: 600,
		});

		$win.on('resize', function() {
			$('.js-news-slider').slick('resize');
		});
	}

	// お客様の声
	var $messe_slider = $('.js-messe-slider');

	if($messe_slider.length > 0) {

		$messe_slider.slick({
			dots: true,
			arrows: false,
			centerMode: true,
			variableWidth: true,
  			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 4000,
			speed: 600,
		});
	}

	// 導入事例
	var $case_slider = $('.js-case-slider');

	if($case_slider.length > 0) {

		$case_slider.slick({
			dots: true,
			arrows: false,
			centerMode: true,
			variableWidth: true,
  			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 4000,
			speed: 600,
		});
	}

	// セミナー
	var $seminar_slider = $('.js-seminar-slider');

	if($seminar_slider.length > 0) {

		if(!$seminar_slider.hasClass('is-sp--slider')) {
			$seminar_slider.slick({
				dots: true,
				arrows: false,
				centerMode: true,
				variableWidth: true,
	  			slidesToShow: 2,
				slidesToScroll: 1,
				infinite: true,
				autoplay: true,
				autoplaySpeed: 4000,
				speed: 600,
				responsive: [ {
			        breakpoint: 768,
			        settings: 'unslick'
			    }]
			});
			$win.on('resize orientationchange', function() {
				$('.js-seminar-slider').slick('resize');
			});
		}else{
			// sp時にもスライダーにする場合
			$seminar_slider.slick({
				dots: true,
				arrows: false,
				centerMode: true,
				variableWidth: true,
	  			slidesToShow: 2,
				slidesToScroll: 1,
				infinite: true,
				autoplay: true,
				autoplaySpeed: 4000,
				speed: 600,
			});
		}
	}
}


/* アコーディオン */
function set_accord() {

	//スムーススクロール処理
	$(document).on('click','.js-accord-btn', function() {
	
		var $this = $(this),
			$parents = $this.parents('.js-accord'),
			$target = $parents.find('.js-accord-target');

		if($this.hasClass('is-open')) {
			$this.removeClass('is-open').addClass('is-close');
			$target.slideUp('300');
		}else{
			$this.removeClass('is-close').addClass('is-open');
			$target.slideDown('300');
		}
	

	});

}

/* textarea 自動可変 */
function set_textarea_auto() {

	var $textarea = $('.js-textarea');

	if($textarea.length <= 0) {
		return false;
	}

	var tar_h = $textarea.outerHeight();

	$textarea.each( function() {

		var $this = $(this);

		$this.on('input', function() {

			var $this = $(this);

			$this.css({'height': tar_h});

			var scrl_h = $this.get(0).scrollHeight;
			$this.css({'height': scrl_h});

		});
	});
}


/* macth height */
function init_matchheight() {
	$('.js-match-height').matchHeight();
}


/* tel-autoformat */
function set_tel_autoformat() {
	if($('.js-number-format').length > 0) {

		var $this = $('.js-number-format'),
			before_val = 0,
			max_length = $this.attr('maxlength');

		// 最大文字数を定義
		if(!max_length) {
			max_length = 13;
		}

		$this.on('input', function(e) {

			var number = $this.val(),
				check_len = number.length;

			// TIPS 日本語入力の時も気を付ける
			number = check_number_format(number);

			if((number.match(/-/) && number.length <= max_length) && check_len >= before_val) {
				$this.val(number);
			}
			before_val = number.length;
		});
	}
}

/* link copy */
function set_linkcopy() {

	var $tar = $('.js-copylink');
	var reset_messe = '';

	if($tar.length <= 0) {
		return false;
	}

	$tar.on('click', function() {

		clearTimeout(reset_messe);

		var elem = document.createElement('input');
		var $this = $(this);
		var $messe = $this.next('.js-copylink--messe');

		elem.value = location.href;
		document.body.appendChild(elem);
		elem.select();
		document.execCommand('copy');
		document.body.removeChild(elem);

		$messe.css({'display': 'block'});

		reset_messe = setTimeout(function() {
			$messe.css({'display': 'none'});
		}, 1000);


	});
}

/* form validation */
function set_form_validation() {

	// フォーム用ID
	var $form_wrap_id = $("#download_form");

	if($form_wrap_id.length <= 0) {
		return false;
	}

	var $tar_form = $form_wrap_id.find('form');
	var $mail_form = $tar_form.find('.js-mailform');
	var form_type = $form_wrap_id.data('type');
	var change_flag = false;
	let CONFIG_PATH = '';
	var $prog_bar = $('#js-form-prog');
	var para = '';
	var url_para = location.search.substring(1);
	var _url_para = url_para.split('&');

	// 入力中の離脱防止処理
	$win.on('beforeunload', function() {
		//変更がある場合のみ警告をだす
		if (change_flag) {
			return "ページを閉じようとしています。\n入力した情報が初期化されてしまいますがよろしいですか？";
		}
	});
	$form_wrap_id.on('submit',function(){
		$win.off('beforeunload');
	});
	// 入力されたらフラグ変更
	$("#download_form input, #download_form textarea, #download_form select").on('change', function() {
		change_flag = true;
	});

	// パラメータに応じてチェックを入れる
	for(var i=0; _url_para[i]; i++) {
		if(_url_para[i].match(/path=/)) {
			var kv = _url_para[i].split('=');
			para = kv[1];
		}
	}
	if(para === 'web-mtg') {
		$('input[value="オンラインでの相談希望"]').prop('checked', true);
	}else if(para === 'agency') {
		$('input[value="代理店希望"]').prop('checked', true);
	}else if(para === 'sindan') {
		$('input[value="「sindan（シンダン）」サービスに関して"]').prop('checked', true);
	}


  	// enterキーのsubmitを無効化
  	$tar_form.on('keypress', function(e) {

	    var e = e || window.e;
	    var key;
	    var type;

	    //KeyCodeの設定
	    if (e.keyCode != 0) {
	        key = e.keyCode
	    } else {
	        key = e.charcode
	    }

	    //Typeの取得
	    if (document.all) {
	        type = e.srcElement.type;
	    } else {
	        type = e.target.type;
	    }

	    //SubmitとTextArea以外の場合は抑止
	    if (key == 13) {
	        if (type != 'submit' && type != 'textarea') {
	            e.keyCode = 0;
	            e.charcode = 0;
	            return false;
	        }
	    }
  	});

  	// プログレスバー
  	if($prog_bar.length > 0 && get_browser() != 'msie') {
		var circle = new ProgressBar.Circle('#js-form-prog', {
			color: '#61b3b0',
			trailColor: '#d3ede7',
			strokeWidth: 3,
			duration: 800,
			easing: 'easeInOut',
		});
  	}

  	// フォームによってバリデーションの内容を変える
	switch (form_type) {

		case 'contact':

		    CONFIG_PATH = '/wp/wp-content/themes/sinclo/assets/js/data/validator_config_contact.json';
			break;

		case 'seminar':

		    CONFIG_PATH = '/wp/wp-content/themes/sinclo/assets/js/data/validator_config_seminar.json';
			break;

		case 'simple_form':

		    CONFIG_PATH = '/wp/wp-content/themes/sinclo/assets/js/data/validator_config_simpleDownload.json';
			break;

		case 'white_paper':

			CONFIG_PATH = '/wp/wp-content/themes/sinclo/assets/js/data/validator_config_whitepaper.json';
			break;

		case 'download':

			CONFIG_PATH = '/wp/wp-content/themes/sinclo/assets/js/data/validator_config_download.json';
			break;

		case 'case':

			CONFIG_PATH = '/wp/wp-content/themes/sinclo/assets/js/data/validator_config_case_download.json';
			break;

		case 'download_seminar':

			CONFIG_PATH = '/wp/wp-content/themes/sinclo/assets/js/data/validator_config_download_seminar.json';
			break;

		case 'trial':

			CONFIG_PATH = '/wp/wp-content/themes/sinclo/assets/js/data/validator_config_trial.json';
			break;

		default:
			break;
	}

  	//バリデーション
    const SUCCESS_MSG = '入力OK';

    var error_map = {},
    order_map = {
  		'required' : 1,
  		'email' : 2,
  		'spam' : 3,
  		'zip' : 2,
  		'tel' : 2,
  		'checked' : 2
    },
	$mail_form = $('.js-mailform'),
	$count_num = $('.js-prog-count'),
	valid_count = $mail_form.length,
	count_split = 100 / valid_count,
	check_leng = 0,
	now_count = 0,
	first_flag = true,
    // 電話番号チェック
    is_tel = function(val) {
      // 値が空の場合は検証しない
      var result = true;

	  if(!is_not_empty(val) || !libphonenumber.isValidNumber(val, 'JP') || !val.match(/^[0]/) || !(val.match(/^\d{2,5}-\d{1,4}-\d{3,4}$|^\d{10,11}$/) || val.match(/^\d{10,11}$/)) ) {
        result = false;
      }
      return result;
    },
    // 値がメールアドレス形式かどうかを検証する
    is_email = function(val) {
      // 値が空の場合は検証しない
      var result = true;
      if(!is_not_empty(val)) return false;
      if(!val.match(/^([*+!.&#$|\'\\%\/0-9a-z^_`{}=?~:-]+)@(([0-9a-z-]+\.)+[0-9a-z]{2,})$/i)) {
        result = false;
      }
      return result;
    },
    // トライアル用 - すでに登録されているユーザーかチェックする（フォーカスアウトのタイミングのほうがいいかもしれない）
    is_trial_custom_email = function(val) {

        var validationUrl = "https://sinclo.jp/Trial/check";
        var result = true;

		$.ajax({
			type: "POST",
			url: validationUrl,
			data: $('#download_form').serialize(),
			async: false
		}).done(function(data){
			if(data.trim() == 'メールアドレスの形式が不正です。' || data.trim() == '既に登録されているアドレスです。' || data.trim() == 'フリーアドレスのご利用はできません。' || data.trim() == '携帯電話のメールアドレスのご利用はできません。') {
		        result = false;
			}
        });
        return result;
    },
    // スパムドメインを検証する
    is_spam = function(val) {
      var result = true;
      if(!val.match(/^([\w-\.]+@(?!qq.com)([\w-]+\.)+[\w-]{2,4})?$/)) {
        result = false;
      }
      return result;
    },
    // 空の値をチェック（空文字も不可）
    is_not_empty = function(val) {
      var result = true;
      if(!val || $.trim(val) === "") {
        result = false;
      }
      return result;
    },
    // 必須チェック
    is_required = function(val) {

      var result = true;
      if(!is_not_empty(val)) {
        result = false;
      }
      return result;
    },
    //チェックボックス
    is_checked = function(key) {
      var result = true;
      $('[name="'+key+'"]').each(function(index, el) {
        if (!$(el).prop('checked')) {
          result = false;
        } else {
          result = true;
          return false;
        };
      });

      return result;
    },
    // バリデーションの各種メソッドを呼び出し、結果を返す
    check_val = function(key, val, type) {
      var result = true;
      switch(type) {
        case 'required':
          result = is_required(val);
          break;
        case 'email':
          result = is_email(val);
          break;
        case 'spam':
          result = is_spam(val);
          break;
        case 'zip':
          result = is_zip(val);
          break;
        case 'tel':
          result = is_tel(val);
          break;
        case 'checked':
          result = is_checked(key);
          break;
        case 'trial_custom_email':
          result = is_trial_custom_email(key);
          break;
        default:
          result = true;
          break;
      }
      return result;
    },
    // エラー項目のリストを作成
    set_error_map = function($elm, type, result, message) {
      var id = $elm.attr('id');
      if (result) {
        // エラー無
        if (error_map[id]) {
          for(var i = 0; i < error_map[id].length; i++){
            if(error_map[id][i]['type'] === type) {
              // エラーでない場合リストから削除
              error_map[id].splice(i,1);
              if (error_map[id].length === 0) {
                delete error_map[id];
              }
              break;
            }
          }
        }
      } else {
        // エラー有
        if (!error_map[id]) {
          var arr = [];
          arr.push({
            'type': type,
            'message': message,
            'order': order_map[type]
          });
          error_map[id] = arr;
        } else {
          var type_arr = [];
          for(i = 0; i < error_map[id].length; i++){
            type_arr.push(error_map[id][i]['type']);
          }
          // リストに追加済でなければ追加
          if (type_arr.indexOf(type) < 0) {
            error_map[id].push({
              'type': type,
              'message': message,
              'order': order_map[type]
            });
          }
        }
      }
    },
    // 画面に表示するバリデーション結果を保有するindexを取得
    get_disp_index = function(id) {
      var disp_index = 0,
        order_arr = [];
      for(i = 0; i < error_map[id].length; i++){
        order_arr.push(error_map[id][i]['order']);
      }
      order_arr.sort(function(a,b){
        if( a < b ) return -1;
        if( a > b ) return 1;
        return 0;
      });
      for(i = 0; i < error_map[id].length; i++){
        if(error_map[id][i]['order'] === order_arr[0]) {
          disp_index = i;
          break;
        }
      }
      return disp_index;
    },
    // 画面にメッセージを表示し結果のmapを作成
    set_result = function($elm, type, result, message) {
		var id = $elm.attr('id');
		var $parents = $elm.parents('.js-mailform');
		var $submit_btn = $('.js-form-btn');

		// エラー項目のリストを作成
		set_error_map($elm, type, result, message);
		$parents.removeClass('is-error');

		if(error_map[id]) {
			// エラーがあったら
			$parents.removeClass('is-checked');
			$parents.addClass('is-error');

			$submit_btn.each( function() {
				if($(this).hasClass('is-entry')) {
					$(this).css({'display': 'none'}).removeClass('js-entry_comp');
				}else{
					$(this).css({'display': 'block'});
				}
			});

		} else {
			$parents.addClass('is-checked');

			if($('.js-mailform').length === $('.js-mailform.is-checked').length) {

				$submit_btn.each( function() {
					if($(this).hasClass('is-desabled')) {
						$(this).css({'display': 'none'});
					}else{
						$(this).css({'display': 'block'}).addClass('js-entry_comp');
					}
				});
			}
		}

		// プログレスバーの更新
		if($prog_bar.length > 0) {

		    check_leng = $('.js-mailform.is-checked').length;

			if(count_split * check_leng / 100 !== now_count) {
				now_count = count_split * check_leng / 100;
				circle.animate(now_count);
				$count_num.text(valid_count - check_leng);

				if(valid_count - check_leng === 0) {
					$('.js-prog-label').addClass('is-comp');
				}else{
					$('.js-prog-label').removeClass('is-comp');
				}
			}
		}
    },
	// バリデーション実装
	valid = function($elm, type, key, message) {
		$elm.on('change keyup', function() {

			if(type === 'trial_custom_email') {
				return false;
			}
			var result = true,
				val = $elm.val();
			if(key === 'tel') {
				$elm.val(val);
			}
			if(!check_val(key, val, type)) {
				result = false;
			}

			// セミナーの場合、項目が分かれているので個別チェック
			if(form_type === 'seminar') {
				//姓を判定したとき名も判定する
				if (key === 'name' && check_val(key, val, type)) {
					if (!check_val('name02', $('input#name02').val(), 'required')) {
						result = false;
					} else {
						result = true;
					};
				};
				//名を判定したとき姓も判定する
				if (key === 'name02' && check_val(key, val, type)) {
					if (!check_val('name01', $('input#name01').val(), 'required')) {
						result = false;
					};
				};
			}
			set_result($elm, type, result, message);
			return false;
		});
		$elm.on('blur', function() {

			var result = true;
			var val = $elm.val();

			// サーバー負荷解消のためblurのタイミングで既存メールアドレスチェックをする
			if(type === 'trial_custom_email') {

				if(!check_val(key, val, type)) {
					result = false;
				}

				set_result($elm, type, result, message);
				return false;
			}
		});
	};

	//対象商品の自動チェック判定
	setTimeout(function(){
		if($('input[name="inquiry_type"]:checked').length > 0) {
			$('input[name="inquiry_type"]:checked').trigger('change', true);
		}
	}, 500);

	// 設定ファイルを取得しバリデーションの処理を呼び出す
	$.getJSON(CONFIG_PATH, function(data) {
		$(data).each(function() {
			var key = this.key,
			type = this.type,
			message = this.message,
			selector = '[name="' + key + '"]';

			$(selector).each(function() {
				valid($(this), type, key, message);
			});
		});
	});

	// 送信ボタンの連打対策
	$('.js-form-submit').on('click', function () {

		var $this = $(this);

		$this.css('pointer-events','none');

		setTimeout( function() {
			$this.css('pointer-events','unset');
		}, 2000);

		// submit成功時
		if($('.js-submit-loader').length > 0) {
			$('.js-submit-loader').addClass('is-active');
		}
	});
}

/* simple form title add hidden */
function set_simple_form_title() {

	var $send_page_title = $('input[name="send_page_title"]');

	if($send_page_title.length > 0) {

		var page_title = document.title;
		$send_page_title.val(page_title);
	}
}

/* form trial add */
function set_trial_add() {

	var $trial_tdd_btn = $('.js-trial-btn');

	$trial_tdd_btn.on('click', function() {

		var $trial_data = $('.js-trial-data');
		var destinationUrl = $trial_data.find('input[name="destinationUrl"]').val();
		var destinationPage = $trial_data.find('input[name="destinationPage"]').val();

		// ローディング
		$('.js-submit-loader').addClass('is-active');

		if (!$("#agree").is(':checked')) {
			document.getElementById('agreeEroor').style.display = "block";
			$('.js-submit-loader').removeClass('is-active');
			return false;
		}

		$.ajax({
			type: "POST",
			url: '/wp/wp-content/themes/sinclo/assets/include/trial_so_id.php',
			data: 'get_so_id'
		}).done(function(so_id){

			// hiddenタグを仕込む
			$("<input>", {
				type: 'hidden',
				id: 'input_so_id',
				name: 'data[MAgreements][so_id]',
				value: so_id
			}).appendTo('#download_form');

			// 識別番号を挿入後にcall
			$('#input_so_id').ready( function() {
				$.ajax({
					type: "POST",
					url: destinationUrl,
					data: $('#download_form').serialize()
				}).done(function(data){

					var $form = $('#download_form');
					$form.submit();

				}).fail(function(data){
					var obj = JSON.parse(data.responseText);
					alert(obj.message);
					$("#submitButton").remove();
				});
			});
		});

	});

}




/* click action */
function set_action_ripple() {

	var $clickable = $('.js-ripple');

	/* mousedownだと直ぐに発動し、clickだとマウスボタンを離した時に発動する */
	$clickable.on('mousedown', function(e) {
		var _self   = this;
		var x       = e.offsetX;
		var y       = e.offsetY;

		var $effect = $(_self).find('.js-ripple--effect');
		var w       = $effect.width();
		var h       = $effect.height();

		/* クリックした座標を中心とする */
		$effect.css({
			left: x - w / 2,
			top: y - h / 2
		});

		/* jsではclassの付け替えをするだけ */
		if (!$effect.hasClass('is-show')) {
			$effect.addClass('is-show');

			/*
			* エフェクトアニメーションが終わったらclassを削除する
			* ここでは、単純にcssで設定するdurationと時間を合わせているだけですが
			* keyframes終了のイベント(AnimationEnd)が取れるかと思うので、それで対応した方が良いかも
			*/
			setTimeout(function() {
				$effect.removeClass('is-show');
			}, 750);
		}
		return false;
	});
}


/* 目次をpopupで表示 */
function set_toc_popup() {

	var $toc_btn = $(".js-toc-btn");
	var $toc_close = $(".js-toc-close");
	var $tar_obj = $('.js-toc');

	if($tar_obj.length <= 0) {
		return false;
	}

	$toc_btn.on('click', function() {
		$tar_obj.fadeIn(200);
	});
	$toc_close.on('click', function() {
		$tar_obj.fadeOut(200);
	});
}

/* セミナーバナー */
function set_banner_fix() {
	// セミナーバナー表示
  	var $fix_banner   = $('#js-banner');
  	var $get_cookie   = get_cookie_array();
  	var $banner_html = '';
  	var rand_flag = ['default', 'seminar'];
  	var img_pc = '';
  	var img_sp = '';
  	var alt = '';
  	var link = '';

  	if($get_cookie['close_banner'] === 'close' || $fix_banner.length < 0) {
  		return false;
  	}

  	// バナーが2つある場合
  	/*
  	if(rand_flag[Math.floor(Math.random() * rand_flag.length)] === 'default') {
  		img_pc = '/wp/wp-content/themes/sinclo/assets/img/common/banner/award2021_japan_banner.jpg';
  		img_sp = '/wp/wp-content/themes/sinclo/assets/img/common/banner/award2021_japan_banner_sp.jpg';
  		alt = '「ITreview Best Software in Japan 2021」にて、sincloがTOP50に選出されました！';
  		link = '/news/itreview-best-software-in-japan2021/?scfixbnr';
  	}else {
  		img_pc = '/wp/wp-content/themes/sinclo/assets/img/common/banner/seminar_banner1222-02.png';
  		img_sp = '/wp/wp-content/themes/sinclo/assets/img/common/banner/seminar_banner1222-03.png';
  		alt = 'チャットボットでCVR150％アップ！？自社サイトで派遣スタッフ登録・応募率を向上させるチャットボット活用術！';
  		link = '/seminar/2021-12-22/?scfixbnr';
  	}
  	*/

  	// バナーが1つの場合
	img_pc = '/wp/wp-content/themes/sinclo/assets/img/common/banner/award2021_japan_banner.jpg';
	img_sp = '/wp/wp-content/themes/sinclo/assets/img/common/banner/award2021_japan_banner_sp.jpg';
	alt = '「ITreview Best Software in Japan 2021」にて、sincloがTOP50に選出されました！';
	link = '/news/itreview-best-software-in-japan2021/?scfixbnr';


  	// バナーを挿入する
  	$banner_html = '<button type="button" id="js-banner-close" class="c-banner__close"><span class="c-banner__closeInner"><span></span><span></span></span></button>';
  	$banner_html += '<a href="' + link + '" class="c-banner__anchor">';
  	$banner_html += '<img src="' + img_pc + '" width="350" height="180" alt="' + alt + '" class="pc">';
  	$banner_html += '<img src="' + img_sp + '" width="300" height="50" alt="' + alt + '" class="sp">';
  	$banner_html += '</a>';

  	$fix_banner.html($banner_html).removeClass('is-hidden');

	var view_pos = $win.height() * 1.5;
	var $ban_close = $('#js-banner-close');

	$win.on('scroll', function() {
        var scrlTop = $win.scrollTop();
        var winH    = $win.height();
        var scrlPos = scrlTop + winH;

		//メニュー表示切替
		if (scrlTop > view_pos) {
			$fix_banner.addClass("is-show");
		} else {
			$fix_banner.removeClass("is-show");
		};
	});

	// バナークローズ
	$ban_close.on('click', function() {
		$fix_banner.fadeOut(200);

		// クッキーに保存
		document.cookie = 'close_banner=' + encodeURIComponent('close') + '; Path=/';
	});
}

/* 無限スクロール */
function set_infinite_scroll() {

	var $tar_scroll = $('#js-infinite-scroll');

	if($tar_scroll.length <= 0) {
		return false;
	}

	var infScroll = new InfiniteScroll('#js-infinite-scroll', {
		append: '#js-infinite-scroll .js-infinite--item',
		path: '.nextpostslink',
		button: '#more-button',
		status: '.js-infinite--scroller',
		scrollThreshold: true,
		history: false,
		onInit: function() {
			this.on( 'append', function() {
				init_matchheight();
			});
		}
	});
}

/* ハンバーガーメニュー */
function set_sp_menu_switch() {

	var $menu_btn = $('.js-menu-btn');
	var $menu_tar = $('.js-menu-tar');

	if($menu_btn.length <= 0) {
		return false;
	}

	$menu_btn.on('click', function() {

		if($body.hasClass('is-side-menu-open')) {
			// フィルターアリの時は別作動のボタンとする
			$body.removeClass('is-side-menu-open');
		}else{
			if($menu_tar.hasClass('is-menu-open')) {
				$menu_tar.removeClass('is-menu-open');
			}else{
				$menu_tar.addClass('is-menu-open');
			}
		}
	});
}

/* ハンバーガーメニュー */
function set_sp_filter_switch() {

	var $menu_btn = $('.js-side-menu-btn');

	if($menu_btn.length <= 0) {
		return false;
	}

	// classを追加する
	$menu_btn.on('click', function() {
		if($body.hasClass('is-side-menu-open')) {
			// フィルターアリの時は別作動のボタンとする
			$body.removeClass('is-side-menu-open');
		}else{
			$body.addClass('is-side-menu-open');
		}
	});
}


/* 絞り込み機能 */
function set_mixitup_filter() {
	
	var $filter_tar = $('.js-mixitup-filter');

	if($filter_tar.length <= 0) {
		return false;
	}

	// mixitupの読み込み
	var $mixit_btn = $('.js-mixitup-btn');
	mixitup($filter_tar, {});

	$mixit_btn.on('click', function() {

		var $this = $(this);

		$mixit_btn.each( function() {
			$mixit_btn.removeClass('is-current');
		});

		$this.addClass('is-current');
	});
}

/* 無料トライアル用の利用規約ポップアップ */
function set_terms_popup() {

	var $terms_btn = $('.js-terms--popup');

	if($terms_btn.length <= 0) {
		return false;
	}

	var modalUrl = "/wp/wp-content/themes/sinclo/assets/include/remoteTermsOfService.html";
	var tar_obj = $('.js-toc');
	var tar_main = $('.js-toc-main');

	$terms_btn.on('click', function() {
		$.ajax({
			type: 'post',
			dataType: 'html',
			cache: false,
			url: modalUrl,
			success: function(html){
				tar_obj.fadeIn(200);
				tar_main.html(html);
			}
		});
	});
}

/* 無料トライアル用の利用規約ポップアップ */
function set_blog_toc() {

	// お役立ち記事にのみ使用する
	var $body = $('#id-blog-single');
	if($body.length <= 0) {
		return false;
	}
	var $content = $body.find('.js-entry-content');
	if($content.length <= 0) {
		return false;
	}

    var contentsList = document.getElementById('toc');
    var div = document.createElement('div'); // 作成する目次のコンテナ要素
    var ttl = document.createElement('div');

    contentsList.setAttribute('class', 'c-toc03');
    ttl.setAttribute('class', 'c-toc03__ttl');
    ttl.innerHTML = '<i class="fas fa-list-ul"></i>目次';
    div.appendChild(ttl);


    // .entry-content配下のh2、h3要素を全て取得する
    var matches = document.querySelectorAll('.js-entry-content h2, .js-entry-content h3');

    // 取得した見出しタグ要素の数だけ以下の操作を繰り返す
    matches.forEach(function (value, i) {
        // 見出しタグ要素のidを取得し空の場合は内容をidにする
        var id = value.id;
        if(id === '') {
            id = value.textContent;
            value.id = id;
        }

        // 要素がh2タグの場合
        if(value.tagName === 'H2') {
            var ul = document.createElement('ul');
            var li = document.createElement('li');
            var a = document.createElement('a');

            // 追加する<ul><li><a>タイトル</a></li></ul>を準備する
            a.innerHTML = value.textContent;
            a.href = '#' + value.id;
            li.appendChild(a)
            ul.appendChild(li);

            // コンテナ要素である<div>の中に要素を追加する
            div.appendChild(ul);
        }

        // 要素がh3タグの場合
        if(value.tagName === 'H3') {
            var ul = document.createElement('ul');
            var li = document.createElement('li');
            var a = document.createElement('a');

            // コンテナ要素である<div>の中から最後の<li>を取得する。
            var lastUl = div.lastElementChild;
            var lastLi = lastUl.lastElementChild;

            // 追加する<ul><li><a>タイトル</a></li></ul>を準備する
            a.innerHTML = value.textContent;
            a.href = '#' + value.id;
            li.appendChild(a)
            ul.appendChild(li);

            // 最後の<li>の中に要素を追加する
            lastLi.appendChild(ul);
        }

    });
    contentsList.appendChild(div);
}

/* 無料トライアル用の利用規約ポップアップ */
function set_support_toc() {

	// お役立ち記事にのみ使用する
	var $body = $('#id-support-detail');
	if($body.length <= 0) {
		return false;
	}
	var $content = $body.find('.js-entry-content');
	if($content.length <= 0) {
		return false;
	}

    var contentsList = document.getElementById('toc');
    var div = document.createElement('div'); // 作成する目次のコンテナ要素
    var ttl = document.createElement('div');

    contentsList.setAttribute('class', 'c-toc02');
    ttl.setAttribute('class', 'c-toc02__ttl');
    ttl.innerHTML = '目次';
    div.appendChild(ttl);


    // .entry-content配下のh2、h3要素を全て取得する
    var matches = document.querySelectorAll('.js-entry-content h2, .js-entry-content h3');

    // 取得した見出しタグ要素の数だけ以下の操作を繰り返す
    matches.forEach(function (value, i) {
        // 見出しタグ要素のidを取得し空の場合は内容をidにする
        var id = value.id;
        if(id === '') {
            id = value.textContent;
            value.id = id;
        }

        // 要素がh2タグの場合
        if(value.tagName === 'H2') {
            var ul = document.createElement('ul');
            var li = document.createElement('li');
            var a = document.createElement('a');

            // 追加する<ul><li><a>タイトル</a></li></ul>を準備する
            a.innerHTML = value.textContent;
            a.href = '#' + value.id;
            li.appendChild(a)
            ul.appendChild(li);

            // コンテナ要素である<div>の中に要素を追加する
            div.appendChild(ul);
        }

        // 要素がh3タグの場合
        if(value.tagName === 'H3') {
            var ul = document.createElement('ul');
            var li = document.createElement('li');
            var a = document.createElement('a');

            // コンテナ要素である<div>の中から最後の<li>を取得する。
            var lastUl = div.lastElementChild;
            var lastLi = lastUl.lastElementChild;

            // 追加する<ul><li><a>タイトル</a></li></ul>を準備する
            a.innerHTML = value.textContent;
            a.href = '#' + value.id;
            li.appendChild(a)
            ul.appendChild(li);

            // 最後の<li>の中に要素を追加する
            lastLi.appendChild(ul);
        }

    });
    contentsList.appendChild(div);

    $(document).ready(function(){
		//URLのハッシュ値を取得
		var urlHash = location.hash;

		//ハッシュ値があればページ内スクロール
		if(urlHash) {
			setTimeout(function () {
				scrollToAnker(urlHash);
			}, 100);
		}
		// 関数：スムーススクロール
		// 指定したアンカー(#ID)へアニメーションでスクロール
		function scrollToAnker(hash) {
			var target = $(decodeURI(hash));
			var position = target.offset().top;
			// $('body, html').stop().animate({scrollTop: position}, speed, 'swing');
			$('body,html').stop().scrollTop(position);
		}
    });
}



function set_function_tabs() {

	var $btn = $('.js-tab--btn');

	if($btn.length  <= 0) {
		return false;
	}

	$btn.on('click', function() {

		var $this = $(this);
		var tar_type = $this.data('target');
		var $parent = $this.parents('.js-tab--parent');
		var $btn_list = $parent.find('.js-tab--btn');
		var $tar_list = $parent.find('.js-tab--tar');

		$tar_list.css({'display': 'none'});

		$tar_list.each( function() {
			if($(this).data('type') === tar_type) {
				$(this).css({'display': 'block'});
			}
		});

		$btn_list.removeClass('is-current');
		$this.addClass('is-current');
	});
}

/* 外部連携サービスのタブ */
function set_api_tabs() {

	var $button = $('.js-api--tab button');
	var $logos = $('.js-api--logo li');

	$button.on('click', function() {

		var $this = $(this);
		var tar_type = $this.data('type');
		var $tar_logos = '';

		if(tar_type !== 'all') {
			$tar_logos = $('.js-api--logo li[data-type="' + tar_type + '"]');
		}else{
			$tar_logos = $('.js-api--logo li');
		}

		var logos_re = $tar_logos.length % 6;

		// current変更
		$button.removeClass('is-current');
		$this.addClass('is-current');

		// 非表示
		$logos.css({'display': 'none'}).removeClass('is-last');
		$tar_logos.fadeIn(200);

		if(logos_re !== 0) {

			var $last_line = $tar_logos.slice(-logos_re);

			$last_line.each( function() {
				$(this).addClass('is-last');
			});
			
		}
	});
}


/* 操作マニュアルのメニュー展開 */
function set_manual_menu() {

	$(".js-menuML-parent").hover(
		function(){
			var $this = $(this);
			var $tar = $this.find('.js-menuML-tar');
			$tar.slideDown(300);
		}, function() {
			var $this = $(this);
			var $tar = $this.find('.js-menuML-tar');
			$tar.slideUp(300);
		}
	);
}

/* ======================================
	function name
====================================== */
/*
* 市外局番に応じたチェックを行う
* input:入力された数値
*/
function check_number_format($input) {
	return new libphonenumber.AsYouType('JP').input($input.replace(/\r?\n/g,""));
}


/*
* cookieを取得して連想配列にする
*/
function get_cookie_array() {

    var arr = new Array();

    if(document.cookie != ''){
        var tmp = document.cookie.split('; ');
        for(var i=0;i<tmp.length;i++){
            var data = tmp[i].split('=');
            arr[data[0]] = decodeURIComponent(data[1]);
        }
    }
    return arr;
}


});